import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

type IsikRenk = 'kirmizi' | 'sari' | 'yesil';

const ISIK_RENKLERI: Record<IsikRenk, string> = {
  kirmizi: '#f5222d',
  sari: '#faad14',
  yesil: '#52c41a',
};

@Component({
  selector: 'widget-trafik-isigi',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="trafik-kasa">
      <svg viewBox="0 0 60 140" class="trafik-svg">
        <defs>
          @for (isik of isiklar(); track isik.renk) {
            <filter [attr.id]="'glow-' + isik.renk" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceGraphic" [attr.stdDeviation]="4"/>
            </filter>
          }
        </defs>
        <rect x="5" y="5" width="50" height="130" rx="12" class="kasa"/>
        @for (isik of isiklar(); track isik.renk) {
          <circle
            [attr.cx]="30"
            [attr.cy]="isik.cy"
            r="16"
            [attr.fill]="isik.aktif ? isik.hex : '#333'"
            [attr.filter]="isik.aktif ? 'url(#glow-' + isik.renk + ')' : ''"
            [attr.opacity]="isik.aktif ? 1 : 0.3"/>
        }
      </svg>
    </div>
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; justify-content: center; }
    .trafik-kasa { display: inline-block; }
    .trafik-svg { width: 48px; height: auto; }
    .kasa { fill: #1a1a1a; stroke: #333; stroke-width: 1.5; }
  `],
})
export class TrafikIsigiComponent {
  aktifIsik = input<IsikRenk>('yesil');

  isiklar = computed(() => {
    const aktif = this.aktifIsik();
    return ([
      { renk: 'kirmizi' as IsikRenk, cy: 32 },
      { renk: 'sari' as IsikRenk, cy: 70 },
      { renk: 'yesil' as IsikRenk, cy: 108 },
    ]).map(i => ({
      ...i,
      hex: ISIK_RENKLERI[i.renk],
      aktif: i.renk === aktif,
    }));
  });
}
